import React from 'react';
import CartElementItinerary from "./CartElementItinerary";
import {removeExcursionFromCart} from '../../actions/cartActions';
import {formatTimeByTheme} from "../../utils/themeUtils";
import ExcursionDuration from "../ExcursionDuration";
import { useLingui } from '@lingui/react/macro';

function CartExcursionEntryItinerary(props){
    const excursion = props.excursion;
    const {t} = useLingui();
    return (
        <CartElementItinerary
            price={excursion.price}
            name={excursion.excursionName}
            imageReference={excursion.excursionId}
            imageCategory="cruiseExcursion"
            remove={() => removeExcursionFromCart(excursion.itineraryId, excursion.excursionId)}
            linkTo={ t({id: "/excursion"}) + `/${excursion.itineraryId}/${excursion.excursionId}`}
            changePassengersLinkText={t({id: "change_passengers"})}
            changePassengersLinkTo={t({id: "/excursion"})  + `/${excursion.itineraryId}/${excursion.excursionId}/passengers`}
            status={excursion.status}
        >
            <ul className="list-reset my-2 xl:grow">
                {excursion.passengers.map((passenger, index) =>
                    <li key={index}>{`${passenger.firstName} ${passenger.lastName}`}</li>)}
            </ul>
            <div className="my-2">
                <div>{excursion.bookingCode}</div>
                <div>{formatTimeByTheme(excursion.fromTime)}</div>
                <ExcursionDuration duration={excursion.duration} />
            </div>
        </CartElementItinerary>
    )
}


export default CartExcursionEntryItinerary;